import React from 'react';
import Icon, { IIcon } from './Icon';
import { colors } from 'constants/colors';

const IosIcon: React.FC<IIcon> = ({ color = colors.white, ...props }) => (
  <Icon width="16" height="24" viewBox="0 0 16 24" fill="none" {...props}>
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8948 4.19689C12.1761 2.62864 11.9088 1 11.9088 1C11.9088 1 10.1158 1.00805 8.82636 2.74071C7.68 4.2801 7.97213 5.59737 7.97213 5.59737C7.97213 5.59737 9.5268 5.87116 10.8934 4.19621L10.8948 4.19689ZM13.3547 11.5986C13.3547 8.91437 15.4782 7.80915 15.4782 7.80915C15.4782 7.80915 14.3916 5.80942 11.6342 5.80942C10.0311 5.80942 8.80017 6.73883 8.13666 6.73883C7.36437 6.73883 6.21129 5.86445 4.72512 5.86445C2.43778 5.86445 0 7.95142 0 11.9294C0 15.9711 2.87966 21 5.16029 21C5.95542 21 7.17767 20.1827 8.40797 20.1827C9.61679 20.1827 10.5073 20.9705 11.655 20.9705C14.1519 20.9705 16 15.6692 16 15.6692C16 15.6692 13.3561 14.6257 13.3561 11.5986H13.3547Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="24" fill={color} />
      </clipPath>
    </defs>
  </Icon>
);

export default IosIcon;
